<template>
  <div class="form-input-container">
    <div><input type="file" name="form-file" :ref="ref_id" style="display: none;" accept="application/pdf, image/png, image/jpg, image/jpeg" @change="handleAttachmentFile($event)"/></div>
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div>{{translate(label)}} <span class="required" v-if="required">*</span></div>
      <div>
        <md-button class="md-raised md-primary file-button" v-if="loading"><i class="material-icons button-icon rotate">loop</i>{{translate(locale.loading)}}</md-button>
        <md-button v-else-if="!loading && !localValue.url" class="md-raised md-primary file-button" @click="$refs[ref_id].click()"><i class="material-icons button-icon">attachment</i>{{translate(locale.upload)}}</md-button>
        <div class="file-container" v-if="localValue.url">
          <div style="margin-right: 10px;"><b>{{localValue.filename}}</b></div>
          <md-button class="md-raised md-primary file-button" @click="download(localValue)"><i class="material-icons button-icon">download</i>{{translate(locale.download)}}</md-button>
          <md-button class="md-raised md-danger file-button" @click="remove()"><i class="material-icons button-icon">delete</i>{{translate(locale.delete)}}</md-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'stats-card',
    props: {
      value: {}, label:{},
      required: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        loading: false,
        localValue: this.value,
        ref_id: "ID" + parseInt(Math.random() * 90000)
      }
    },
    created() {
      this.setFieldValue();
    },
    methods: {
      remove() {
        this.localValue = {url: "", filename: ""}
      },
      setFieldValue() {
        this.localValue = this.model
      },
      handleAttachmentFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs[this.ref_id].files[0]);
				this.loading = true;

				this.$http.post(this.config.api + "/user/file/upload", formData).then(res => {
					this.loading = false;
					if (res.body.status == 'success') {
						this.localValue = res.body.data;
					}
				})
			},
    },
    watch: {
      model() {
        this.setFieldValue()
      },
      localValue(val) {
        this.$emit('input', val)
      },
      value(val) {
        this.localValue = val
      }
    },
    computed: {
      model: {
        get() {
          return this.localValue
        },
        set(value) {
          if (value.constructor.name.toLowerCase() !== 'inputevent') {
            this.$nextTick(() => {
              this.localValue = value
            })
          }
        }
      },
    }
  }
</script>

<style scoped>
  .form-input-container {
    color: #353690;
  }

  .file-button {
    /* margin-left: 5px; */
    margin: 5px 5px;
  }
  .form-title {
    margin-bottom: 8px;
  }
  .file-container {
    display: flex;
    align-items: center;
  }
  .rotate {
    animation: rotation 1s infinite linear;
    -moz-animation: rotation 1s infinite linear;
    -webkit-animation: rotation 1s infinite linear;
  }
  @keyframes rotation {
    from {-webkit-transform: rotate(0deg);}
    to   {-webkit-transform: rotate(359deg);}
  }
  @-moz-keyframes rotation {
    from {-webkit-transform: rotate(0deg);}
    to   {-webkit-transform: rotate(359deg);}
  }
  @-webkit-keyframes rotation {
    from {-webkit-transform: rotate(0deg);}
    to   {-webkit-transform: rotate(359deg);}
  }
  .form-input {
    width: 100%;
    height: 38px;
    font-size: 14px;
    padding: 4px 12px;
    border: 2px solid #EEE;
    border-radius: 6px;
    font-family: "Open Sans", "Hanuman", sans-serif;
    color: #353690;
  }

  .form-input:focus {
    border: 2px solid #353690;
  }
</style>


// WEBPACK FOOTER //
// src/components/Form/File.vue